import { ReactComponent as RepeatIcon } from 'resources/images/repeat.svg';
import { Icon } from '@chakra-ui/react';
import {
  ButtonWithActiveState,
  ButtonWithActiveStateProps,
} from '../ButtonWithActiveState';

export const RepeatButton = (props: ButtonWithActiveStateProps) => (
  <ButtonWithActiveState {...props}>
    <Icon as={RepeatIcon} w={4} h={4} data-testid="audio-repeat-button" />
  </ButtonWithActiveState>
);
